.edgeRow {
  display: grid;
  grid-template-columns: 3fr 1fr 3fr;
  column-gap: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.emojiContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.emoji {
  font-size: 20px;
}
